import { Category, Group } from "@/sharedTypes";
import { baseApi } from "../baseApi";
import { flattenQueryParams } from "@/utils/requestUtils";

const categoryTag = "Category";
const subcategoryTag = "Subcategory";
const groupTag = "Group";

export const categoryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPaginatedCategories: builder.query<any, Record<string, any> | void>({
      query: (params) => {
        const searchParams = new URLSearchParams();
        
        if (params) {
           const { filters, pagination } = params as any;
           
           if (filters) {
               Object.entries(filters).forEach(([key, value]) => {
                   if (value !== undefined && value !== null && value !== "") {
                       searchParams.append(key, String(value));
                   }
               });
           }
           
           if (pagination) {
               Object.entries(pagination).forEach(([key, value]) => {
                   if (value !== undefined && value !== null) {
                       searchParams.append(key, String(value));
                   }
               });
           }
        }
        
        const queryString = searchParams.toString();
        return `/gw/categories${queryString ? `?${queryString}` : ""}`;
      },
      providesTags: [categoryTag],
    }),
    createCategory: builder.mutation({
      query: (payload: Category) => ({
        url: "/gw/categories",
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [categoryTag],
    }),
    updateCategory: builder.mutation({
      query: ({ category_id, ...payload }: Category) => ({
        url: `/gw/categories/${category_id}`,
        method: "PUT",
        body: payload,
      }),
      invalidatesTags: [categoryTag, subcategoryTag],
    }),
    deleteCategory: builder.mutation({
      query: (id: number) => ({
        url: `/gw/categories/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [categoryTag, subcategoryTag],
    }),
    restoreCategory: builder.mutation({
      query: (id: number) => ({
        url: `/gw/categories/${id}/restore`,
        method: "PUT",
      }),
      invalidatesTags: [categoryTag, subcategoryTag],
    }),
    hardDeleteCategory: builder.mutation({
      query: (id: number) => ({
        url: `/gw/categories/${id}/permanent`,
        method: "DELETE",
      }),
      invalidatesTags: [categoryTag, subcategoryTag],
    }),

    // Groups
    getGroups: builder.query<any, Record<string, any> | void>({
      query: (params) => {
         const queryString = params
          ? `?${new URLSearchParams(flattenQueryParams(params)).toString()}`
          : "";
        return `/groups${queryString}`;  
      },
      providesTags: [groupTag],
    }),
    createGroup: builder.mutation({
      query: (payload: Group) => ({
        url: "/groups", 
        method: "POST",
        body: payload,
      }),
      invalidatesTags: [groupTag],
      transformResponse: (response: any) => response?.data,
    }),
  }),
});

export const {
  useGetPaginatedCategoriesQuery,
  useCreateCategoryMutation,
  useUpdateCategoryMutation,
  useDeleteCategoryMutation,
  useRestoreCategoryMutation,
  useHardDeleteCategoryMutation,
  useGetGroupsQuery,
  useCreateGroupMutation,
} = categoryApi;
